export const ACCOUNTS_DATA = "ACCOUNTS_DATA"